/* One submission path and serialized drawer mutations. Native checkout stays native. */
(function ($) {
  var queue = Promise.resolve();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var refreshVersion = 0;
  function request(path, options) {
    return fetch(root + path, Object.assign({ credentials: 'same-origin' }, options)).then(function (response) {
      if (!response.ok) return response.json().catch(function () { return {}; }).then(function (error) {
        throw new Error(error.description || error.message || 'Unable to update your cart. Please try again.');
      });
      return response;
    });
  }
  function enqueue(task) {
    var next = queue.then(task);
    queue = next.catch(function () {});
    return next;
  }
  function errorMessage(container, error) {
    var message = container.find('.wagging-cart-error');
    if (!message.length) message = $('<p class="wagging-cart-error" role="alert"></p>').prependTo(container);
    message.text(error.message);
  }
  function refresh(themeCart) {
    var version = ++refreshVersion;
    return Promise.all([
      request('cart?view=json').then(function (r) { return r.text(); }),
      request('cart.js').then(function (r) { return r.json(); })
    ]).then(function (results) {
      if (version !== refreshVersion) return;
      $('#cart-info').html(results[0]);
      themeCart.doUpdateMiniCart(results[1]);
      $('#desktop_cart').toggleClass('item_count', results[1].item_count > 0);
      if (window.Currency && typeof Currency.convertAll === 'function') {
        Currency.convertAll(window.shopCurrency, $('#currencies span.selected').attr('data-currency'));
      }
      if (results[1].item_count > 0) {
        if (!$('.form-cart__extent').length) themeCart.initCartExtend();
      } else {
        var empty = $('<div class="cart cart_empty"></div>');
        $('<div class="empty_title text-center"></div>').text(theme.strings.cart_empty).appendTo(empty);
        $('<div class="text-center mt-40 block_link_cart"></div>').html($('.link_to_collection_cart_empty').html()).appendTo(empty);
        $('#cart-info').empty().append(empty);
        $('.form-cart__extent').remove();
      }
    });
  }
  window.WaggingCart = {
    refresh: function (themeCart) {
      return enqueue(function () { return refresh(themeCart); }).catch(function (error) {
        errorMessage($('#cart-info'), error);
      });
    },
    init: function (themeCart) {
      $(document).off('submit.waggingCart').on('submit.waggingCart', 'form', function (event) {
        var form = $(this);
        var button = form.find('.product-form__cart-submit, button.btnAddToCart').first();
        if (!button.length || (event.originalEvent && event.originalEvent.submitter && event.originalEvent.submitter.name === 'checkout')) return;
        event.preventDefault();
        if (form.data('cartPending') || button.prop('disabled') || button.closest('.soldout').length) return;
        form.data('cartPending', true);
        button.addClass('loading').attr('aria-busy', 'true');
        form.find('.wagging-cart-error').remove();
        var data = new FormData(this);
        enqueue(function () {
          return request('cart/add.js', { method: 'POST', body: data }).then(function (r) { return r.json(); }).then(function (item) {
            return refresh(themeCart).then(function () {
              if (theme.cart_status === 'goto_page_cart') { window.location.href = root + 'cart'; return; }
              if (theme.cart_status === 'show_popup') themeCart.initAddToCart(item.image, item.title);
              if (theme.cart_status === 'show_minicart') {
                $('#desktop_cart').addClass('active');
                $('.sidebar-overlay').addClass('act');
              }
              $('.quickviewClose').trigger('click');
            }).catch(function () {
              // Addition succeeded: navigate to the cart rather than inviting a duplicate retry.
              window.location.href = root + 'cart';
            });
          });
        }).catch(function (error) { errorMessage(form, error); }).finally(function () {
          form.data('cartPending', false);
          button.removeClass('loading').removeAttr('aria-busy');
        });
      });
      var selectors = '#cart-info .cart__mini-qty, #cart-info .remove-from-cart';
      $(document).off('click.waggingCart', selectors).on('click.waggingCart', selectors, function (event) {
        event.preventDefault();
        var control = $(this);
        var input = control.closest('.cart__item-bottom').find('.cart__mini-qty--input');
        var quantity = control.hasClass('remove-from-cart') ? 0 : Number(input.val()) + (control.hasClass('cart__mini-qty--plus') ? 1 : -1);
        change(input, quantity);
      });
      $(document).off('change.waggingCart', '#cart-info .cart__mini-qty--input').on('change.waggingCart', '#cart-info .cart__mini-qty--input', function () {
        change($(this), Number(this.value));
      });
      function change(input, quantity) {
        if (!Number.isInteger(quantity) || quantity < 0) { input.val(input.attr('value')); return; }
        var drawer = $('#cart-info');
        if (drawer.attr('aria-busy') === 'true') return;
        drawer.attr('aria-busy', 'true');
        var key = input.attr('data-id');
        enqueue(function () {
          return request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) })
            .then(function () { return refresh(themeCart); });
        }).catch(function (error) {
          input.val(input.attr('value'));
          errorMessage(drawer, error);
        }).finally(function () { drawer.removeAttr('aria-busy'); });
      }
    }
  };
})(jQuery);
